module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/configurator/configurator.component.css
// module id = ./src/app/components/configurator/configurator.component.css
// module chunks = main